<template>
  <div class="blog-page container">
    <h1>Blog</h1>

    <template v-if="posts.length">
      <post
        v-for="post in posts"
        :key="post.id"
        :post="post"
        class="animated fadeInUp"
      ></post>
    </template>
    <template v-else>
      <h3 v-if="!loading">No Posts</h3>
      <div v-else class="load-spinner"></div>
    </template>
  </div>
</template>

<script>
import axios from "axios";
import post from "@/components/BlogPost";

export default {
  name: "Blog",
  components: {
    post
  },
  data() {
    return {
      posts: [],
      loading: true
    };
  },
  mounted() {
    axios
      .get("/blog")
      .then(response => {
        this.posts = response.data.posts;
      })
      .finally(() => {
        this.loading = false;
      });
  }
};
</script>
